<div class="course-selector">
  <div class="course-selector__nodes">
    <p-tree
      #tree
      [value]="coursesTree$ | async"
      selectionMode="single"
      [filter]="true"
      [(selection)]="selectedCourse"
      (onNodeSelect)="handleNodeSelection($event)"
      styleClass="quote-tool-lite__course-selector__tree"
      data-qa="courseSelection__tree"
    >
      <ng-template let-node pTemplate="courseType">
        <div class="course-selector__nodes__course-type" tabindex="0">
          <span class="course-selector__nodes__course-type__name">{{ node.label }}</span>
        </div>
      </ng-template>

      <ng-template let-node pTemplate="course">
        <div class="course-selector__nodes__course" tabindex="0">
          <span class="course-selector__nodes__course__name">{{ node.label }}</span>
          <span class="course-selector__nodes__course__duration">{{ node.subLabel }}</span>
        </div>
      </ng-template>
    </p-tree>
  </div>
</div>
